import { authRoles } from '../../../auth/authRoles';
import Admin from './Admin';
import EditAdmin from './EditAdmin';
import TambahAdmin from './TambahAdmin';

const adminRoute = [
  {
    path: "/admin/edit/:id",
    exact: true,
    component: EditAdmin,
    auth: authRoles.sa,
  },
  {
    path: "/admin/tambah",
    exact: true,
    component: TambahAdmin,
    auth: authRoles.sa,
  },
  {
    path: "/admin",
    exact: true,
    component: Admin,
    auth: authRoles.sa,
  },
];

export default adminRoute;
